
import banner from '../../res/banner@2x.jpg';
export const AdPage= ()=>{
    return(<div style={{margin:"16px"}}>
        <img src={banner} style={{width:"100%",height:"100%"}}></img>
    </div>);
}